import { vuexfireMutations, firestoreAction } from "vuexfire";
import { db } from "@/plugins/db.js";

export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    workProfile: {},
    works: [],
    inventory: []
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    bindWorks: firestoreAction(context => {
      return context.bindFirestoreRef(
        "works",
        db.collection("works").where("disabled", "==", false)
      );
    }),
    bindAWork: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "workProfile",
        db.collection("works").doc(id)
      );
    }),
    bindAnInventory: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "inventory",
        db.collection(`works/${id}/inventory`)
      );
    })
  },
  getters: {}
};
